module.exports = __webpack_public_path__ + "static/img/xls.703f897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat/images/chat_files/xls.png
// module id = tuVE
// module chunks = 1